<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4" v-if="currentModel != null">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title >{{$t('gameVersions.style')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-form ref="updateForm">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                  <v-img contain max-height="200px" :src="config.filesUrl + currentModel.instance + '/logo/' + currentModel.style.logo"></v-img>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  color="primary"
                  block
                  @click.native="$refs.logoInput.click()"
                  :loading="$store.state.gameVersions.loading"
                >{{$t('gameVersions.updateLogo')}}</v-btn>
                <input
                  ref="logoInput"
                  type="file"
                  accept=".png, .jpeg, .jpg"
                  @change="uploadLogo($event)"
                  style="display:none"
                >
              </v-flex>
              <v-flex xs16>
                <v-text-field
                  :label="$t('gameVersions.colors.primary')"
                  v-model="currentModel.style.colors.primary"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
                <v-card height="20px" :color="currentModel.style.colors.primary"></v-card>
              </v-flex>
              <v-flex xs16>
                <v-text-field
                  :label="$t('gameVersions.colors.secondary')"
                  v-model="currentModel.style.colors.secondary"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
                <v-card height="20px" :color="currentModel.style.colors.secondary"></v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.companies.loading"
            submit
            flat
            @click.native="update"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            color="primary"
            :disabled="$store.state.companies.loading"
            submit
            flat
            @click.native="getModel"
          >{{$t('general.cancel')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>

import Config from '@/config'
export default {
  name: "GameVersionStyle",
  components: {},
  data() {
    return {
      currentModel: null
    };
  },
  mounted() {
    this.getModel();
  },
  methods: {
    async getModel() {
      let model = await this.$store.dispatch(
        "gameVersions/getOne",
        this.$route.params.id
      );
      this.currentModel = Object.assign({}, model);
    },
    async update() {
      if (this.$refs.updateForm.validate()) {
        if (
          await this.$store.dispatch("gameVersions/update", {
            id: this.currentModel._id,
            data: this.currentModel
          })
        ) {
          this.getModel();
        }
      }
    },
    async uploadLogo(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      let formData = new FormData();
      formData.append("logo", files[0]);
      if (
        await this.$store.dispatch("gameVersions/uploadLogo", {
          id: this.$route.params.id,
          data: formData
        })
      ) {
        this.getModel();
      }
      this.$refs["logoInput"].value = "";
    }
  },
  computed: {
    config () {
      return Config
    }
  }
};
</script>
